import { hrmsSupabase, supabase } from '../../../services/supabase';
import { TTeamWiseLeaves } from '../types';

export const getTeamWiseCheckInData = async (
  startDate: string,
  endDate: string,
): Promise<{
  checkIns: {
    team_name: string;
    check_in_date: string;
    check_in_count: number;
  }[];
  leaves: TTeamWiseLeaves[];
}> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data, error: aggregatedCheckInsError } = await supabase.rpc(
    'get_teamwise_check_ins',
    {
      start_date: startDate,
      end_date: endDate,
    },
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data: leaves, error: leavesError } = await hrmsSupabase.rpc(
    'get_teamwise_leaves',
    {
      start_date: startDate,
      end_date: endDate,
    },
  );
  if (aggregatedCheckInsError || leavesError) {
    throw new Error('Error fetching data');
  }
  return {
    checkIns: (data || []) as {
      team_name: string;
      check_in_date: string;
      check_in_count: number;
    }[],
    leaves: (leaves || []) as TTeamWiseLeaves[],
  };
};
